<template>
    <div class="profile text--white">
        <div class="box box--space-vertical">
            <!--
            <div class="profile-content__section">
                Weather
            </div>
            -->
            <div v-if="accountDetail"
                class="profile-content__section profile-info">
                <div class="profile-info__section">
                    <div class="profile__avatar"
                        :style="{
                            backgroundImage: `url(${getImageFileUrl(accountDetail.avatar)})`
                        }">
                    </div>
                </div>
                <div class="profile-info__section">
                    <div class="profile-info__heading">
                        {{accountDetail.name}} {{accountDetail.surname}}
                    </div>
                    <div class="profile-info__subheading">
                        {{accountDetail.email}}
                    </div>
                </div>
            </div>
        </div>


        <div v-if="compositionsRequest === 'success'">
            <div class="box box--center">
                <div class="headline--sixth headline--colored">
                    Historia
                </div>
            </div>
            <ul class="profile-compositons">
                <li v-for="theme in compositions"
                    :key="theme.hash">
                    <div class="profile-compositons__item"
                        @click="() => onThemeClick(theme)"
                        :style="{
                            backgroundImage: `url(${getImageThemeUrl(theme)})`
                        }">
                        <div class="profile-compositions__text">
                            <span class="">
                                {{theme.name}}
                            </span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div v-else-if="compositionsRequest === 'request'">
            <div class="box box--center">
                <app-spinner />
            </div>
        </div>

        <div class="box box--center box--spaces">
            <button
                type="button"
                class="button  normal--button button--small-text button--uppercase button--shadow"
                @click.prevent="logout">
                Odhlasit
            </button>
        </div>
    </div>
</template>

<script>

import {
    getImageFileUrl,
    getImageThemeUrl,
    openMapComposition,
    getPersonalizedThemesPromise,
    logout
} from '../../services/MapsfyApi';

export default {
    data() {
        return {
            compositionsRequestCount: 6,
            compositions: null,
            compositionsRequest: null
        }
    },
    mounted() {
        this.compositionsRequest = 'request';
        getPersonalizedThemesPromise(this.compositionsRequestCount)
            .then(res => {
                this.compositionsRequest = 'success';
                if (res && res.length && res.length > this.compositionsRequestCount) {
                    this.compositions = res.slice(0, this.compositionsRequestCount);
                } else {
                    this.compositions = res;
                }
            })
            .fail(error => {
                this.compositionsRequest = 'failure';
                console.log('Error loading personalize compositions: ', error);
            });
    },
    methods: {
        getImageThemeUrl: getImageThemeUrl,
        getImageFileUrl: getImageFileUrl,
        logout: logout,
        onThemeClick(theme) {
            this.$router.push({name: 'mapApp'});
            openMapComposition(theme.hash);
        }
    },
    computed: {
        accountDetail() {
            const accountDetail = this.$store.getters['auth/accountDetail'];
            return accountDetail;
        }
    }
}
</script>

<style lang="scss" scoped>
$color: #00AEBA;

@media (min-width: 375px) {
    .profile {
        min-width: 325px;
    }
}

.profile-content__section {
    padding: 1rem 2rem;
}

.profile-info {
    display: flex;

    .profile-info__section {
        padding-right: 1.5rem;
    }

    .profile-info__heading {
        padding: 1rem 0 0.6rem 0;
        font-size: 1.7rem;
        color: $color;
    }
    .profile-info__subheading {
        font-size: 1.1rem;
    }
}

.profile__avatar {
    height: 70px;
    width: 70px;
    border: 3px solid $color;
    border-radius: 100%;

}

.profile-content {
    cursor: initial;
}

.profile-compositons {
    padding: 0;
    margin: 0;
}

.profile-compositons__item {
    cursor: pointer;
    height: 8rem;
    position: relative;
    background-size: cover;
}

.profile-compositions__text {
    background-color: rgba(32, 44, 54, 0.45);
    color: white;
    position: absolute;
    bottom: 0px;
    top: 0;
    padding:  2rem 1rem;
    margin: 1rem;
    left: 0px;
    width: 50%;
    border-radius: 0.15rem;
}
</style>
